import * as React from 'react';

import { NewForgeExperienceAlert } from '@src/components/new-forge-experience-alert';
import { StatusBarContainer } from '@src/components/status-bar/status-bar-container';
import { WarehouseContainer } from './warehouse-container';

interface OwnProps {
  warehouseId: string;
}

export const WarehouseDetailsContainer: React.FC<OwnProps> = ({ warehouseId }) => {
  return (
    <>
      <NewForgeExperienceAlert />
      <StatusBarContainer />
      <WarehouseContainer warehouseId={warehouseId} showLinkedRegions />
    </>
  );
};
